import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_API_URL || "";
export const TOKEN_KEY = "kb_access_token";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// Attach the bearer token (if any) to every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const apiService = {
  // --- auth ---
  login: async (username, password) => {
    const res = await api.post("/api/login", { username, password });
    return res.data; // { access_token, user, ... }
  },

  getMe: async () => {
    const res = await api.get("/api/me");
    return res.data; // { username, role }
  },

  // SSO: the URL to send the browser back to another app, token attached.
  ssoHandoff: async (returnUrl) => {
    const res = await api.post("/api/sso/handoff", { return_url: returnUrl });
    return res.data; // { redirect_url }
  },

  // Topics for the landing page.
  listTopics: async () => {
    const res = await api.get("/api/topics");
    return res.data;
  },

  // Lessons within one topic.
  listTopicLessons: async (topicSlug) => {
    const res = await api.get(`/api/topics/${topicSlug}/lessons`);
    return res.data;
  },

  // --- admin settings ---
  adminListTopics: async () => {
    const res = await api.get("/api/admin/topics");
    return res.data;
  },

  setTopicVisibility: async (topicSlug, visibility) => {
    const res = await api.patch(`/api/admin/topics/${topicSlug}`, { visibility });
    return res.data;
  },

  // All lessons (list view).
  listLessons: async () => {
    const res = await api.get("/api/lessons");
    return res.data;
  },

  // One lesson's full content.
  getLesson: async (slug) => {
    const res = await api.get(`/api/lessons/${slug}`);
    return res.data;
  },

  // A short-lived signed GCS URL for the lesson's audio.
  getAudioUrl: async (slug) => {
    const res = await api.get(`/api/lessons/${slug}/audio-url`);
    return res.data; // { url, expires_in }
  },
};

export default apiService;
